import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/jhon_cesar.jpg"
                alt="Jhon Cesar"
                className="w-10 h-10 rounded-full object-cover"
              />
              <span className="font-bold text-lg">Jhon Cesar</span>
            </div>
            <p className="text-white/70 leading-relaxed">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold mb-4">{t('footer.navTitle')}</h3>
            <ul className="space-y-2 text-white/70">
              <li><a href="#portfolio" className="hover:text-white transition-colors duration-200">{t('footer.portfolio')}</a></li>
              <li><a href="#testimonios" className="hover:text-white transition-colors duration-200">{t('footer.testimonios')}</a></li>
              <li><a href="#proceso" className="hover:text-white transition-colors duration-200">{t('footer.proceso')}</a></li>
              <li><a href="#faq" className="hover:text-white transition-colors duration-200">{t('footer.faq')}</a></li>
              <li><a href="#contacto" className="hover:text-white transition-colors duration-200">{t('footer.contacto')}</a></li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h3 className="font-bold mb-4">{t('footer.socialTitle')}</h3>
            <ul className="space-y-2 text-white/70">
              <li><a href="https://www.youtube.com/@isoyjhoncesar" target="_blank" className="hover:text-white transition-colors duration-200">YouTube</a></li>
              <li><a href="https://www.instagram.com/soyjhoncesar/" target="_blank" className="hover:text-white transition-colors duration-200">Instagram</a></li>
              <li><a href="https://www.tiktok.com/@isoyjhoncesar" target="_blank" className="hover:text-white transition-colors duration-200">TikTok</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 text-center text-white/60 text-sm">
          <p>{t('footer.copyright').replace('{year}', currentYear)}</p>
        </div>
        <div className="text-center text-white/60 text-sm mt-2">
          <p>{t('footer.developedBy')} <a href="https://portfolio-5tj11ydxx-juancodevs-projects.vercel.app/" target="_blank" className="hover:text-white transition-colors duration-200 mt-2">@juancodev</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;